import * as React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, MuiThemeProvider, Theme as MuiTheme, ThemeOptions } from '@material-ui/core/styles';

export const baseTheme: ThemeOptions = {
  palette: {
    primary: { main: '#006E96' },
    secondary: { main: '#007853' },
    error: { main: '#B00020', light: '#FFBB33' }
  },
  typography: {
    h6: {
      fontWeight: 400
    }
  },
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)'
      }
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: '#002E41'
      }
    }
  }
};

const theme = createMuiTheme(baseTheme);

type Props = {
  themeOverride?: MuiTheme;
};

export const Theme: React.FC<Props> = ({ children, themeOverride }) => (
  <MuiThemeProvider theme={themeOverride || theme}>
    <CssBaseline />
    {children}
  </MuiThemeProvider>
);
